/* The legacy Klaviyo form QNpMh5 still contains 30-Night copy.
   Keep its storefront rendering aligned with the confirmed 90-day policy.
   This scoped compatibility fix can be removed once the app source is updated. */
(() => {
  const selector = 'form[data-testid="klaviyo-form-QNpMh5"]';
  function correctForm(form) {
    form.querySelectorAll('.klaviyo-form-richtext p').forEach(paragraph => {
      if (!/Money-Back Guarantee/i.test(paragraph.textContent)) return;
      const walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (/30[-–\s]Night\b/i.test(node.data)) node.data = node.data.replace(/30[-–\s]Night\b/gi, '90-Day');
      }
    });
  }
  function inspect(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const form = node.parentElement?.closest(selector);
      if (form) correctForm(form);
      return;
    }
    if (!(node instanceof Element)) return;
    const form = node.closest(selector);
    if (form) correctForm(form);
    node.querySelectorAll(selector).forEach(correctForm);
  }
  document.querySelectorAll(selector).forEach(correctForm);
  new MutationObserver(records => records.forEach(record => {
    if (record.type === 'characterData') inspect(record.target);
    else record.addedNodes.forEach(inspect);
  })).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
